import { FileWithPath } from '@mantine/dropzone';
import { FileValidationErrors } from '@/app/assets/components/upload/hooks/useFileValidation';
import { Box, Button, Divider, Group, Modal, Stack, Text } from '@mantine/core';
import RawAssetUploader from '@/app/assets/components/upload/molecules/RawAssetUploader';
import { ScrollableModal } from '@/app/components/modal/ScrollableModal';

export function AssetsUploadModal({
  credits,
  fileValidationErrors,
  files,
  onClose,
  onFileDropped,
  opened,
  removeAllFiles,
  removeFile,
  storageLeft,
  storageLimit,
  uploadFiles,
  uploadPending,
  hasErrors,
  isValidating,
}: {
  opened: boolean;
  onClose: () => void;
  storageLimit: number;
  storageLeft: number;
  credits: number;
  onFileDropped: (droppedFiles: FileWithPath[]) => Promise<void>;
  uploadPending: boolean;
  uploadFiles: () => void;
  files: FileWithPath[];
  removeFile: (index: number) => Promise<void>;
  removeAllFiles: () => Promise<void>;
  fileValidationErrors: FileValidationErrors;
  isValidating: boolean;
  hasErrors: boolean;
}) {
  return (
    <ScrollableModal
      size='800'
      opened={opened}
      onClose={onClose}
      title='Upload Files'
      nonScrollableBottom={
        <Group gap='xs' justify='end' h={60}>
          <Button
            variant='default'
            onClick={() => {
              removeAllFiles();
              onClose?.();
            }}
          >
            Cancel
          </Button>
          <Button disabled={!files.length || uploadPending || hasErrors} loading={isValidating} onClick={uploadFiles}>
            Upload
          </Button>
        </Group>
      }
    >
      <Box my='sm'>
        <RawAssetUploader
          storageLimit={storageLimit}
          storageLeft={storageLeft}
          credits={credits}
          onFileDropped={onFileDropped}
          isUploadPending={uploadPending}
          files={files}
          removeFile={removeFile}
          removeAllFiles={removeAllFiles}
          fileValidationErrors={fileValidationErrors}
        />
      </Box>
    </ScrollableModal>
  );
}
